import * as moment from 'moment';
import { IAppConfig } from '../store/interfaces/IAppConfig';
import { resolveLocale, useDefault } from './common';
import { ApplicationLocale } from './model/application-locale.model';
import { DateParam } from './model/date-param.model';

const SUNDAY = 7;
const MONDAY = 1;
const SATURDAY = 6;
const ISO_LIMIT = 10;
const FIRST_INDEX = 0;
const SECOND_INDEX = 1;
const THIRD_INDEX = 2;
const ONE_MONTH = 1;
const LOCALE_START_DAY: Map<ApplicationLocale, number> = new Map<ApplicationLocale, number>([
  [ApplicationLocale.en_US, SUNDAY],
  [ApplicationLocale.ar_AE, SATURDAY],
  [ApplicationLocale.en_GB, MONDAY],
  [ApplicationLocale.tr_TR, MONDAY],
  [ApplicationLocale.nl_NL, MONDAY],
  [ApplicationLocale.fr_FR, MONDAY],
  [ApplicationLocale.de_DE, MONDAY],
  [ApplicationLocale.it_IT, MONDAY],
  [ApplicationLocale.pt_PT, MONDAY],
  [ApplicationLocale.es_US, MONDAY],
  [ApplicationLocale.ru_RU, MONDAY],
  [ApplicationLocale.ja_JP, MONDAY],
  [ApplicationLocale.zh_CN, MONDAY],
  [ApplicationLocale.ko_KR, MONDAY],
  [ApplicationLocale.zh_TW, MONDAY]
]);

const LOCALE_FORMAT = {
  'en-US': 'MM/dd/yyyy', 'en-GB': 'dd/MM/yyyy',
  'en-AU': 'dd/MM/yyyy', 'en-NZ': 'dd/MM/yyyy',
  'es-ES': 'dd/MM/yyyy', 'es-US': 'dd/MM/yyyy',
  'fr-FR': 'dd/MM/yyyy', 'de-DE': 'dd/MM/yyyy',
  'it-IT': 'dd/MM/yyyy', 'zh-CN': 'MM/dd/yyyy',
  'en-CN': 'MM/dd/yyyy', 'ja-JP': 'MM/dd/yyyy',
  'ko-KR': 'MM/dd/yyyy', 'iw-IL': 'MM/dd/yyyy',
  'ar-AE': 'MM/dd/yyyy', 'pt-PT': 'dd/MM/yyyy',
  'tr-TR': 'dd/MM/yyyy', 'ru-RU': 'dd/MM/yyyy',
  'nl-NL': 'MM/dd/yyyy', 'zh-TW': 'MM/dd/yyyy'
};

export class DateUtils {
  static resolveCalendarStartingDay(appConfig: IAppConfig) {
    return LOCALE_START_DAY.get(resolveLocale(appConfig)) || SUNDAY;
  }

  static resolveCalendarDateFormat(appConfig: IAppConfig) {
    return LOCALE_FORMAT[resolveLocale(appConfig)] || 'MM/dd/yyyy';
  }
  static toShortISODate(value: Date) {
    const date: Date = useDefault(value, new Date());
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().substring(FIRST_INDEX, ISO_LIMIT);
  }
  static fromISOToDate(value: string, defaultDate = new Date()) {
    const dates = useDefault(value, '').substring(FIRST_INDEX, ISO_LIMIT).split('-');
    return dates.length === 3 ? new Date(Number(dates[FIRST_INDEX]), Number(dates[SECOND_INDEX]) - ONE_MONTH, Number(dates[THIRD_INDEX])) : defaultDate;
  }
  static fromUSLocaleDateToDate(value: string, defaultDate = new Date()) {
    const dates = useDefault(value, '').split('/');
    return dates.length === 3 ? new Date(Number(dates[THIRD_INDEX]), Number(dates[FIRST_INDEX]) - ONE_MONTH, Number(dates[SECOND_INDEX])) : defaultDate;
  }
  static toShortDateUSLocale(value: Date) {
    const date = useDefault(value, new Date());
    return date.toLocaleDateString(ApplicationLocale.en_US).replace(/[^ -~]/g, '');
  }
  static toDateParam(value: any): DateParam {
    const date = useDefault(value, new Date());
    return new DateParam(String(date.getUTCDate()), String(date.getUTCMonth()) + String(date.getUTCFullYear()));
  }
  static toISODate(value: Date) {
    const date: Date = useDefault(value, new Date());
    return date.toISOString();
  }
  static toShortISODateFromString(value: string): string {
    const date = useDefault(value, '');
    return date.length > 0 ? date.substring(0, date.indexOf('T')) : date;
  }
  static formatDate(date: Date): string {
    const momentDate = moment(date);
    let result = '';
    if (momentDate.isValid()) {
      result = momentDate.format('YYYY-MM-DD');
    }
    return result;
  }

  static addDaysTo(date: string, daysToAdd: number = 0): string {
    if (!date) { throw new Error('You must provide a date') };
    return moment(date).add(daysToAdd, 'day').format('YYYY-MM-DD');
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/date.utils.ts